/// <amd-module name="Tfs/Tagging/RestClient/Tagging" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\client\core\clientgeneratorconfigs\tagging\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Tagging from "Tfs/Tagging/Contracts/Tagging";

export interface ITaggingRestClient extends IVssRestClient {
    /**
     * Create a new tag definition.
     * 
     * @param tagData - The data needed to create the new tag.
     * @param scopeId - The scope for the new tag.
     * @param tagId - 
     */
    createTagDefinition(tagData: Tagging.WebApiCreateTagRequestData, scopeId: string, tagId?: string): Promise<Tagging.WebApiTagDefinition>;
    /**
     * Delete a tag definition.
     * 
     * @param scopeId - The scope of the tag.
     * @param tagId - The ID of the tag.
     */
    deleteTagDefinition(scopeId: string, tagId: string): Promise<void>;
    /**
     * Get a tag resource.
     * 
     * @param scopeId - The scope of the tag.
     * @param tagId - The ID of the tag.
     */
    getTagDefinition(scopeId: string, tagId: string): Promise<Tagging.WebApiTagDefinition>;
    /**
     * Get a collection of tags in a scope.
     * 
     * @param scopeId - The scope to return tags for.
     * @param includeInactive - Boolean value to include inactive tags
     * @param artifactKind - The artifactKind to return tags for
     */
    getTagDefinitions(scopeId: string, includeInactive?: boolean, artifactKind?: string): Promise<Tagging.WebApiTagDefinition[]>;
    /**
     * Update a tag definition.
     * 
     * @param tagData - The data needed to update the tag.
     * @param scopeId - The scope of the tag.
     * @param tagId - The ID of the tag.
     */
    updateTagDefinition(tagData: Tagging.WebApiTagDefinition, scopeId: string, tagId: string): Promise<Tagging.WebApiTagDefinition>;
}

class TaggingRestClient extends RestClientBase implements ITaggingRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Create a new tag definition.
     * 
     * @param tagData - The data needed to create the new tag.
     * @param scopeId - The scope for the new tag.
     * @param tagId - 
     */
    public async createTagDefinition(
        tagData: Tagging.WebApiCreateTagRequestData,
        scopeId: string,
        tagId?: string
        ): Promise<Tagging.WebApiTagDefinition> {

        return this.beginRequest<Tagging.WebApiTagDefinition>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "_apis/Tagging/scopes/{scopeId}/tags/{tagId}",
            routeValues: {
                scopeId: scopeId,
                tagId: tagId
            },
            body: tagData
        });
    }

    /**
     * Delete a tag definition.
     * 
     * @param scopeId - The scope of the tag.
     * @param tagId - The ID of the tag.
     */
    public async deleteTagDefinition(
        scopeId: string,
        tagId: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "5.0-preview.1",
            method: "DELETE",
            routeTemplate: "_apis/Tagging/scopes/{scopeId}/tags/{tagId}",
            routeValues: {
                scopeId: scopeId,
                tagId: tagId
            }
        });
    }

    /**
     * Get a tag resource.
     * 
     * @param scopeId - The scope of the tag.
     * @param tagId - The ID of the tag.
     */
    public async getTagDefinition(
        scopeId: string,
        tagId: string
        ): Promise<Tagging.WebApiTagDefinition> {

        return this.beginRequest<Tagging.WebApiTagDefinition>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/Tagging/scopes/{scopeId}/tags/{tagId}",
            routeValues: {
                scopeId: scopeId,
                tagId: tagId
            }
        });
    }

    /**
     * Get a collection of tags in a scope.
     * 
     * @param scopeId - The scope to return tags for.
     * @param includeInactive - Boolean value to include inactive tags
     * @param artifactKind - The artifactKind to return tags for
     */
    public async getTagDefinitions(
        scopeId: string,
        includeInactive?: boolean,
        artifactKind?: string
        ): Promise<Tagging.WebApiTagDefinition[]> {

        const queryValues: any = {
            includeInactive: includeInactive,
            artifactKind: artifactKind
        };

        return this.beginRequest<Tagging.WebApiTagDefinition[]>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/Tagging/scopes/{scopeId}/tags/{tagId}",
            routeValues: {
                scopeId: scopeId
            },
            queryParams: queryValues
        });
    }

    /**
     * Update a tag definition.
     * 
     * @param tagData - The data needed to update the tag.
     * @param scopeId - The scope of the tag.
     * @param tagId - The ID of the tag.
     */
    public async updateTagDefinition(
        tagData: Tagging.WebApiTagDefinition,
        scopeId: string,
        tagId: string
        ): Promise<Tagging.WebApiTagDefinition> {

        return this.beginRequest<Tagging.WebApiTagDefinition>({
            apiVersion: "5.0-preview.1",
            method: "PATCH",
            routeTemplate: "_apis/Tagging/scopes/{scopeId}/tags/{tagId}",
            routeValues: {
                scopeId: scopeId,
                tagId: tagId
            },
            body: tagData
        });
    }

}

export const TaggingClientName = "ITaggingRestClient";

export function getTaggingClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): ITaggingRestClient {
    return pageContext.getRestClient<ITaggingRestClient>(TaggingClientName, options);
}

RestClients.add(TaggingClientName, { 
    factory: TaggingRestClient,
    options: {
        resourceAreaId: "1f131d7f-cfbb-4ec9-b358-fb4e8341ce59",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
